// Simple, safe service worker registration for Focus Hub PWA
// This replaces the problematic default React service worker registration

export function register() {
  if ('serviceWorker' in navigator) {
    // Only register in production or if explicitly enabled
    if (process.env.NODE_ENV === 'production' || process.env.REACT_APP_ENABLE_SW === 'true') {
      window.addEventListener('load', () => {
        const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

        navigator.serviceWorker
          .register(swUrl)
          .then((registration) => {
            console.log('[PWA] Service Worker registered successfully');

            // Check for updates periodically (every hour)
            setInterval(() => {
              registration.update();
            }, 1000 * 60 * 60);

            registration.addEventListener('updatefound', () => {
              const installingWorker = registration.installing;
              if (!installingWorker) return;

              installingWorker.addEventListener('statechange', () => {
                if (installingWorker.state === 'installed') {
                  if (navigator.serviceWorker.controller) {
                    // New update available
                    console.log('[PWA] New update available! Please refresh the page.');
                    // You could show a notification to the user here
                    if (window.confirm('A new version of Focus Hub is available. Would you like to refresh?')) {
                      window.location.reload();
                    }
                  } else {
                    // Content is cached for offline use
                    console.log('[PWA] Content is now available offline!');
                  }
                }
              });
            });
          })
          .catch((error) => {
            console.error('[PWA] Service Worker registration failed:', error);
          });
      });
    } else {
      console.log('[PWA] Service Worker disabled in development mode');
    }
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
        console.log('[PWA] Service Worker unregistered');
      })
      .catch((error) => {
        console.error('[PWA] Service Worker unregistration failed:', error);
      });
  }
}